import React, { useState, useEffect } from "react";
import {useNavigate  } from "react-router-dom";
import ValidarNif from "../components/forms/ValidarNif";
import ValidarEmail from "../components/forms/ValidarEmail";
import ValidarPassword from "../components/forms/ValidarPassword";
import useAxios from "../helpers/useAxios";

const RecuperarPassword = () => {
  const [step, setStep] = useState(1);
  const [nif, setNIF] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [errorNIF, setErrorNIF] = useState('');
  const [errorCode, setErrorCode] = useState('');

  const navigate = useNavigate();

  const { fetch, data, error, loaded, reqStatus } = useAxios("", "", {}, true);

  useEffect(() => {
    if (loaded) {
      if (step === 1)
        doSubmitNif(data, reqStatus)

      if (error.length === 0) 
      {
        if (step === 2)
          doSubmitEmail(data, reqStatus)

        if (step === 3)
          doSubmitPassword(data, reqStatus)
      }
    }

    // if (loaded && error.length === 0)
    // {
    //   if (step === 1)
    //     doSubmitNif(data, reqStatus)

    //   if (step === 2)
    //     doSubmitEmail(data, reqStatus)

    //   if (step === 3)
    //     doSubmitPassword(data, reqStatus)
    // }
  }, [data]);

  const onSubmitNif = dataForm => {
    fetch("POST", "/Auth/forgot-password", { nif: dataForm.nif });
  }

  const doSubmitNif = (data, reqStatus) => {
    if ((data != "" && data != null) || reqStatus === 200)
    {
      setNIF(data.nif);
    }
    else
    {
      setNIF(nif)
    }
    setStep(2);
    
    // if (reqStatus === 200)
    // {
    //   setNIF(data.nif);
    //   setStep(2);
    // }
    // else
    // {
    //   setErrorNIF("Número de identificação fiscal não autorizado.");
    // }
  }

  const onSubmitEmail = (code, email) => {
    setEmail(email)
    fetch("POST", "/Auth/code-validate-singup", { nif: nif, code: code, email: email, ValidationType: 2 });
  }

  const doSubmitEmail = (data, reqStatus) => {
    if (data.name.length && reqStatus === 200)
    {
      setName(data.name);
      setStep(3);
    }
    else
    {
      setErrorCode("De momento não foi possível realizar o seu pedido.");
    }
  }

  const onSubmitRestart = () => {
    setStep(1);
  }

  const onSubmitPassword = dataForm => {
    fetch("POST", "/Auth/update-user-password", { nif: nif, password: dataForm.password, email });
  }

  const doSubmitPassword = (data, reqStatus) => {
      if (data === true && reqStatus === 200)
        navigate("/", {state:{ return: 2 }});
  }

 return (
  <div className="container">
    <div className="row justify-content-md-center">
      <div className="col-md-6 bg-white my-5 rounded-4 p-5 pt-3">
        <div className="row mb-5">
          <div className="col-4 bg-success pt-1"></div>
          <div className={"col-4 " + (step >= 2 ? 'bg-success' : 'bg-light') + " pt-1"}></div>
          <div className={"col-4 " + (step === 3 ? 'bg-success' : 'bg-light') + " pt-1"}></div>
        </div>
        <h1>Área de Cliente</h1>
        {step === 1 && (
          <div>
            <h2>Recuperar palavra-passe</h2>
            <ValidarNif onSubmitHandler={onSubmitNif} errorNIF={errorNIF} checkRequest={false} />
          </div>
        )}
        {step === 2 && (
          <div>
            <h2>Recuperar palavra-passe</h2>
            <ValidarEmail onSubmitHandler={onSubmitEmail} onNewSubmitHandler={onSubmitRestart} errorCode={errorCode} />
          </div>
        )}
        {step === 3 && (
          <div>
            <h2>Definir palavra-passe</h2>
            <ValidarPassword onSubmitHandler={onSubmitPassword} name={name} />
          </div>
        )}
      </div>
    </div>
  </div>
 );
};

export default RecuperarPassword;
